import { Colors } from '@sigma-frontend-libs/commons'

import { components } from '@/utils'

import info from '@/components/info'
import selectorOwner from '@/components/selector/owner'
import expireFields from '@/components/services/url-shortener/commons/form/expireFields'
import domainId from '@/components/services/url-shortener-settings/commons/domainId'
import generationParams from '@/components/services/url-shortener-settings/presets/form/generationParams'
import { serviceNameKebabCase, serviceNameViaPoint } from '@/components/services/url-shortener-settings/presets/utils'

function renderTitleField(h) {
  return h(
    components['text-field'],
    {
      props: {
        value: this.proxy.title,
        label: this.getTranslate('commons.labels.title'),
        dense: true,
        clearable: true,
        details: false
      },
      on: {
        input: event => {
          this.proxy.title = event
        }
      }
    }
  )
}
function renderDomainIdField(h) {
  return h(
    domainId,
    {
      props: {
        value: this.proxy.domainId,
        userId: this.proxy.ownerId,
        prependItems: this.prependItems,
        showWarnings: !this.isNew,
        required: true
      },
      on: {
        input: event => {
          this.proxy.domainId = event
        },
        hasActiveDomains: event => {
          this.hasActiveDomains = event
        }
      }
    }
  )
}
function renderDomainIdInfo(h) {
  if (this.isNew) {
    let domainInfoKey
    if (this.canGetDomainsAsAdmin) {
      domainInfoKey = 'admin'
    } else {
      domainInfoKey = 'user'
    }

    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${serviceNameViaPoint}.infos.domainId.${domainInfoKey}`)
        }
      }
    )
  }
}
function renderDomainIdWarning(h) {
  if (!this.canGetDomains) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${serviceNameViaPoint}.warnings.permissions.get`),
          color: Colors.error
        }
      }
    )
  }
}
function renderDomainIdContent(h) {
  return [
    renderDomainIdField.call(this, h),
    renderDomainIdWarning.call(this, h),
    renderDomainIdInfo.call(this, h)
  ].filter(Boolean)
}

function renderGenerationParams(h) {
  return h(
    generationParams,
    {
      props: {
        value: this.proxy
      },
      on: {
        input: event => {
          this.proxy = event
        },
        validation: event => {
          this.generationParamsValidation = event
        }
      }
    }
  )
}
function renderExpireFields(h) {
  return h(
    expireFields,
    {
      props: {
        value: this.proxy
      },
      on: {
        input: event => {
          this.proxy = event
        },
        validation: event => {
          this.expireUrlValid = event
        }
      }
    }
  )
}
function renderOwnerIdField(h) {
  return h(
    selectorOwner,
    {
      class: 'mt-1',
      props: {
        value: this.proxy.ownerId,
        disabled: !this.isNew,
        dense: true
      },
      on: {
        input: event => {
          this.proxy.ownerId = event
        }
      }
    }
  )
}
function renderFields(h) {
  return [
    renderGenerationParams.call(this, h),
    renderExpireFields.call(this, h),
    renderOwnerIdField.call(this, h)
  ].filter(Boolean)
}

function renderContent(h) {
  if (this.isNew) {
    return renderFields.call(this, h)
  }

  if (this.proxy.domainId) {
    if (this.hasActiveDomains) {
      return renderFields.call(this, h)
    }
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        [`${serviceNameKebabCase}-form`]: true,
        [`${serviceNameKebabCase}-form--new`]: this.isNew
      }
    },
    [
      renderTitleField.call(this, h),
      renderDomainIdContent.call(this, h),
      renderContent.call(this, h)
    ]
  )
}
